import React,
{ useState, useEffect }
from 'react';
import './App.css';
import HashLoader from "react-spinners/HashLoader";

import Header from './components/header/Header';
import Home from './components/home/Home';
import About from './components/about/About';
import Skills from './components/skills/Skills';
import Services from './components/services/Services';
import Qualification from './components/qualification/Qualification';
import Work from './components/work/Work';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';
import ScrollUp from './components/scrollup/ScrollUp';

function App() {

  const [loading, setLoading] = useState(false);

  useEffect( () => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 6000)
  }, [] );

  return (
    <div className="App">

      {
        loading ? 

        <div className='loader__c'>
          <p className="loading__title">Loading</p>
          <HashLoader
            color="#000000"
            loading={loading}
            size={200}
            className="loading"
          />
          <p className="loading__title">ziyadoodle.</p>
        </div>

        :
        
        <div>
          <Header />
          <main className='main'>
            <Home />
            <About />
            <Skills />
            <Services />
            <Qualification />
            <Work />
          </main>
            <Footer />
            <ScrollUp />
        </div>
      }
      
    </div>
  );
}

export default App;
